<template>
    <div class="property-details-navigation">
        <b-button
                class="back-button p-0"
                variant="link"
                @click="navigatePreviousPage"
        >
            <i class="far fa-arrow-left" />
            <span class="back-button-text ml-2 d-none d-lg-inline">
                Back to Search
            </span>
        </b-button>
    </div>
</template>

<script>
    import './PropertyDetailsNavigation.scss';
    import {SEARCH_TABS} from '../../../../helpers/variables';
    import set from 'lodash/set';

    export default {
        name: "PropertyDetailsNavigation",
        props: {
            previousPage: {
                type: [String, Object],
                required: true,
            }
        },
        methods: {
            /**
             * Navigate to the previous page
             */
            navigatePreviousPage() {
                let route =  typeof this.previousPage === 'string'
                    ? { name: this.previousPage }
                    : this.previousPage;

                if (this.$route.query.hasOwnProperty('searchTab')) {
                    set(route, 'query.searchTab', this.$route.query.searchTab);
                }

                this.$router.push(route);

            },
        },
    };
</script>
